import script from "./Orders.vue?vue&type=script&setup=true&lang=ts"
export * from "./Orders.vue?vue&type=script&setup=true&lang=ts"

import "./Orders.vue?vue&type=style&index=0&id=2f6cc0e1&lang=scss"

const __exports__ = script;

export default __exports__